// Module
var code = "<div id=\"backdrop\" onclick=\"_.returns()\"></div>\r\n<div id=\"modalPageContainer\">{{{html}}}</div>";
// Exports
export default code;